const publicRoute = ["/login", "/404"];

const privateRoute = [
  "/dashboard",
  "/report",
  "/task-list",
  "/patient",
  "/patient-list",
  "/caregiver-list",
  "/caregiver",
  "/appointment",
  "/appointment-list",
  "/company",
  "/company-list",
  "/settings",
  "/users",
  "/finance",
  "/invoice",
  "/checkout",
  "/insurance",
  "/insurance-list",
  "/import",
  "/billing",
  "/payment-method",
  "/data-exchange",
  "/hha-config",
];

export const UIConfig = {
  privateRoute,
  publicRoute,
};
